import React from "react";
import { Provider } from "react-redux";
import { createRoot, Root } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { store } from "../../../app/store";
import CategoryMegaMenu from "./CategoryMegaMenu";

// Store created roots by their container ID to reuse if possible
const roots: Record<string, Root> = {};

/**
 * Initializes the CategoryMegaMenu component into the specified DOM element.
 * @param rootId - ID of the DOM element to mount the component into.
 */
export function hydrateCategoryMegaMenu(rootId: string): void {
  const rootElement = document.getElementById(rootId);
  if (!rootElement) {
    console.error(
      `[MegaMenu Hydration] Failed to find root element with ID: ${rootId}`
    );
    return;
  }

  // Prevent re-initialization
  if (rootElement.dataset.reactInitialized === "true") {
    console.log(
      `[MegaMenu Hydration] Container ${rootId} is already initialized.`
    );
    return;
  }

  try {
    // Use existing root or create a new one
    const root = roots[rootId] || createRoot(rootElement);
    if (!roots[rootId]) {
      roots[rootId] = root; // Store the new root
    }

    // Render the component
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            {" "}
            {/* Include Router if using Link/routing inside */}
            <CategoryMegaMenu />
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    );

    // Mark as initialized
    rootElement.dataset.reactInitialized = "true";
    console.log(
      "[MegaMenu Hydration] CategoryMegaMenu component successfully initialized."
    );
  } catch (error) {
    console.error("[MegaMenu Hydration] Error initializing component:", error);
  }
}

// Declare global type for the hydration function
declare global {
  interface Window {
    hydrateCategoryMegaMenu?: (rootId: string) => void;
  }
}

// Make the function globally available
if (typeof window !== "undefined") {
  window.hydrateCategoryMegaMenu = hydrateCategoryMegaMenu;
}
